import React, { useEffect } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../ui/card';

import { Input } from '../ui/input';
import { Label } from '../ui/label';
import { Separator } from '../ui/separator';
import { cutoffsMap, defaultCutoffTimes, getDefault, pretty } from '../../modules/control-tower/cutoff.model';

export const DeliveryAreaCutoffs = ({
  deliveryAreas,
  setCutoffTimes,
}: {
  deliveryAreas: any;
  setCutoffTimes: (v: any[]) => void;
}) => {
  useEffect(() => {
    setCutoffTimes([
      ...deliveryAreas.map((d) => ({
        ...defaultCutoffTimes,
        ...d,
      })),
    ]);
  }, []);

  const setTime = (value, id, type) => {
    const d = deliveryAreas.find((d) => d.id === id);
    const [h, m] = value.split(':').map(Number);
    d[`${type}CutoffHours`] = h;
    d[`${type}CutoffMinutes`] = m;

    setCutoffTimes(deliveryAreas);
  };
  const setDays = (value, id, type) => {
    const d = deliveryAreas.find((d) => d.id === id);
    d[`${type}DaysDiff`] = value;
    setCutoffTimes(deliveryAreas);
  };

  const getPrefillTime = (id, cutoff) => {
    const h = deliveryAreas.find((d) => d.id === id)?.[`${cutoff}CutoffHours`] || getDefault(cutoff, 'hours');
    const m = deliveryAreas.find((d) => d.id === id)?.[`${cutoff}CutoffMinutes`] || getDefault(cutoff, 'minutes');

    return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}`;
  };

  const getPrefilldays = (id, cutoff) =>
    deliveryAreas.find((d) => d.id === id)?.[`${cutoff}DaysDiff`] || getDefault(cutoff, 'days');

  useEffect(() => {}, []);

  return (
    <div className="overflow-auto h-[60vh]">
      {deliveryAreas.map((d) => (
        <Card key={`da-${d.id}`} className="mb-4">
          <CardHeader>
            <CardTitle>{d.name}</CardTitle>
            <CardDescription>Define cutoff times for this delivery area connection</CardDescription>
          </CardHeader>
          <CardContent>
            {Object.entries(cutoffsMap).map(([k, cutoff], i, arr) => (
              <div key={`${d.id}-${cutoff}`}>
                <div className="flex items-center ">
                  <div className="w-1/2 font-bold">{pretty(k)}</div>
                  <div className="flex justify-end w-full">
                    <div className="mr-4">
                      <Label htmlFor={`${cutoff}-time`}>Time</Label>
                      <Input
                        id={`${cutoff}-time`}
                        className="w-16 "
                        type="time"
                        defaultValue={getPrefillTime(d.id, cutoff)}
                        onChange={(e) => setTime(e.target.value, d.id, cutoff)}
                      />
                    </div>
                    <div>
                      <Label htmlFor={`${cutoff}-days`}>Days</Label>
                      <Input
                        id={`${cutoff}-days`}
                        className="w-16"
                        type="number"
                        min={0}
                        defaultValue={getPrefilldays(d.id, cutoff)}
                        onChange={(e) => setDays(Number(e.target.value), d.id, cutoff)}
                      />
                    </div>
                  </div>
                </div>
                {i < arr.length - 1 && <Separator className="my-2" />}
              </div>
            ))}
          </CardContent>
        </Card>
      ))}
    </div>
  );
};
